<template>
  <section>
    <div class="download-filters">
      <product-filter v-for="filter in downloadFilters"
        :key="filter.label"
        :name="filter.label"
        :label="filter.label"
        :options="filter.options"
        :active="activeFilters"
        :related="filter.related"
        @onSelectionChanged="updateFilters"
      />
    </div>
    <div class="grid">
      <table>
        <caption>All Product Downloads</caption>
        <thead class="table-header">
          <tr>
            <th class="product-header-cell">Product</th>
            <th v-for="(type, idx) in resourceTypes" :key="idx" scope="col">{{ type.label }}</th>
            <th>Download All</th>
          </tr>
        </thead>
        <div class="table-header-spacer" />
        <tbody>
            <download-table-row
              v-for="product in this.products"
              :key="product.id"
              :product="product"
              :resourceTypes="resourceTypes"
              :productResources="product.resourceTypeMap"
            />
        </tbody>
      </table>
      <div class="not-found" v-if="this.products.length === 0 && !isLoading">
        <p> No downloads found. </p>
      </div>
      <div class="center-loader" v-if="isLoading">
        <loading-spinner />
      </div>
    </div>
  </section>
</template>

<script>
import DownloadTableRow from '../atoms/download_table_row';
import LoadMore from '../atoms/load_more.js';
import LoadingSpinner from '../atoms/loading_spinner.js';
import ProductFilter from '../atoms/product_filter.js';
import axios from 'axios';

export default {
  components: {
    DownloadTableRow,
    ProductFilter,
    LoadMore,
    LoadingSpinner,
  },
  props: [
    'filters',
    'types'
  ],
  data: function() {
    return {
      endpoint: '/api/product-resources.json',
      activeFilters: {
        to: [],
      },
      isLoading: true,
      products: [],
      resourceTypes: [],
    }
  },
  computed: {
    downloadFilters: function() {
      return JSON.parse(this.filters)
    },
    relatedTo: function() {
      return this.activeFilters.to;
    },
    atLeastOneLeadTime: function () {
      return this.products.some(product => product.leadTime);
    }
  },
  created() {
    this.getProducts().then(() => {
      const types = JSON.parse(this.types);

      if (this.atLeastOneLeadTime) {
        types.push({ label: 'Lead Time', value: 'leadTime'});
      }
      this.resourceTypes = types;
    });
  },
  methods: {
    updateFilters: function (obj) {
      this.activeFilters[obj.related] = this.activeFilters[obj.related].filter(function(value) {
        return value != obj.prev;
      });
      // Make sure an ID was passed.
      if (!isNaN(obj.next)) {
        this.activeFilters[obj.related].push(obj.next);
      }
    },
    mapProductResourcesByType: function (products) {
      return products.map((product) => {
        const resourceTypeMap = new Map();

        product.resources.forEach(({ resourceType, resourceTypeLabel, url, extension, title }) => {
          resourceTypeMap.set(resourceType, { resourceTypeLabel, url, extension, title });
        })
        product.resourceTypeMap = resourceTypeMap;
        return product;
      })
    },
    getProducts: async function(loadMore=false) {
      this.isLoading = true;

      const params = {
        section: 'products',
        orderBy: 'title ASC',
        relatedTo: this.activeFilters['to'],
        limit: Number.MAX_SAFE_INTEGER,
      };
      try {
        const {
          data: {
            data
          }
        } = await axios.get(this.endpoint, { params });

        this.products = this.mapProductResourcesByType(data);

      } catch (error) {
        console.log("API Error: ", error);
        this.products = [];
      }
      this.isLoading = false;
    },
  },
   watch: {
    relatedTo: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getProducts();
      }
    },
  },
}
</script>